import {Card, Row, Col, Modal, InputNumber} from "antd";
import {toFSDateTime} from "../../util/timeutils";
import { EditOutlined } from '@ant-design/icons';
import {useState, useEffect} from 'react';
import {RowMetricType} from "../../api/Constants";
import {getLatestRowMetric, insertRowMetrics} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";

export const MoistureWidget = ({rowId, onApiFail, refresh, onRefresh, props}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const [lowValue, setLowValue] = useState(undefined);
    const [highValue, setHighValue] = useState(undefined);
    const [lowMoisture, setLowMoisture] = useState(undefined);
    const [highMoisture, setHighMoisture] = useState(undefined);

    useEffect(() => {
        getLatestRowMetric(rowId, RowMetricType.LowMoisture).then(r => {
            if (r.length > 0) {
                setLowMoisture(r[0]);
            }
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });
        getLatestRowMetric(rowId, RowMetricType.HighMoisture).then(r => {
            if (r.length > 0) {
                setHighMoisture(r[0]);
            }
        }).catch(e => {
            handleNoSession(e, onApiFail);
        });

    }, [rowId, refresh, onApiFail]);

    const onEdit = () => {
        setModalOpen(true);
    }

    const onLowMoistureChange = (val) => {
        setLowValue(val)
    }

    const onHighMoistureChange = (val) => {
        setHighValue(val)
    }

    const onModalOk = () => {
        const promises = [];
        const now = new Date();
        if (lowValue !== undefined) {
            promises.push(insertRowMetrics(rowId, RowMetricType.LowMoisture, [{timestamp: now, value: lowValue }], false));
        }
        if (highValue !== undefined) {
            promises.push(insertRowMetrics(rowId, RowMetricType.HighMoisture, [{timestamp: now, value: highValue}], false));
        }
        Promise.all(promises).then(r => {
            setLowValue(undefined);
            setHighValue(undefined);
            setModalOpen(false);
            if (onRefresh) onRefresh();
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }

    const onModalCancel = () => {
        setLowValue(undefined);
        setHighValue(undefined);
        setModalOpen(false);
    }

    const gridStyle = {
        width: '50%',
        textAlign: 'center'
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px',
    }

    let lowMoisturePercent = 0;
    let highMoisturePercent = 0;
    let now = toFSDateTime(new Date());
    let lowMoistureTime = now;
    let highMoistureTime = now;
    if ((lowMoisture !== undefined) && (lowMoisture !== null)) {
        lowMoisturePercent = lowMoisture.value;
        lowMoistureTime = toFSDateTime(new Date(lowMoisture.timestamp));
    }
    if ((highMoisture !== undefined) && (highMoisture !== null)) {
        highMoisturePercent = highMoisture.value;
        highMoistureTime = toFSDateTime(new Date(highMoisture.timestamp));
    }

    return <div>
        <Modal open={modalOpen} onOk={onModalOk} onCancel={onModalCancel}>
            <Row style={rowStyle}>
                <Col span={6} style={{marginTop: '5px', marginRight: '10px'}}>
                    <b>Low Moisture:</b>
                </Col>
                <Col>
                    <InputNumber min={0} max={100} placeholder={'low'} value={lowValue} onChange={onLowMoistureChange}/>
                </Col>
            </Row>
            <Row style={rowStyle}>
                <Col span={6} style={{marginTop: '5px', marginRight: '10px'}}>
                    <b>High Moisture:</b>
                </Col>
                <Col>
                    <InputNumber min={0} max={100} placeholder={'high'} value={highValue} onChange={onHighMoistureChange}/>
                </Col>
            </Row>
        </Modal>
        <Card style={{width: '400px'}} type={"inner"} actions={[
            <div onClick={onEdit}>
                <EditOutlined key="edit" />
            </div>,
        ]}>
            <Card.Grid style={{...gridStyle, display: 'grid', placeItems: 'center', backgroundColor: '#03c6fc'}} hoverable={false}>
                <Row style={{fontSize: '25px'}}>{`${lowMoisturePercent} %`}</Row>
                <Row>{lowMoistureTime}</Row>
            </Card.Grid>
            <Card.Grid style={{...gridStyle, display: 'grid', placeItems: 'center', backgroundColor: '#03a5fc'}} hoverable={false}>
                <Row style={{fontSize: '25px'}}>{`${highMoisturePercent} %`}</Row>
                <Row>{highMoistureTime}</Row>
            </Card.Grid>
        </Card>
    </div>
}